import { useCallback, useEffect, useRef } from 'react';

/**
 * Trả về event handlers cho nút "giữ để lặp nhanh".
 * - Nhấn một lần: kích hoạt ngay
 * - Giữ: sau initialDelay ms, bắt đầu lặp mỗi repeatInterval ms
 */
const useHoldRepeat = (action, { initialDelay = 350, repeatInterval = 60 } = {}) => {
    const timeoutRef  = useRef(null);
    const intervalRef = useRef(null);
    const actionRef   = useRef(action);

    useEffect(() => {
        actionRef.current = action;
    }, [action]);

    const stop = useCallback(() => {
        clearTimeout(timeoutRef.current);
        clearInterval(intervalRef.current);
        timeoutRef.current  = null;
        intervalRef.current = null;
    }, []);

    const start = useCallback(() => {
        actionRef.current();
        timeoutRef.current = setTimeout(() => {
            intervalRef.current = setInterval(() => actionRef.current(), repeatInterval);
        }, initialDelay);
    }, [initialDelay, repeatInterval]);

    // Cleanup khi unmount
    useEffect(() => stop, [stop]);

    return {
        onMouseDown:  start,
        onMouseUp:    stop,
        onMouseLeave: stop,
        onTouchStart: (e) => { e.preventDefault(); start(); },
        onTouchEnd:   stop,
    };
};

export default useHoldRepeat;
